import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import RegionJson from '@/assets/json/region.json';
import TwspNameJson from "@/assets/json/township.json";
import "vue-slider-component/theme/default.css";
import axios from "axios";
import $ from "jquery";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
//import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "classList",

    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
    },

    data() {
        return {
            std_id: null,
            keyword: "",
            classes: {},
            pg_status: false,
            attendStudent: [],
            category: [],            
            regionArr: RegionJson,
            twspNameJson: TwspNameJson,
            selectedTwspName: "",
            twspName: [],
            filter: {
                min: "",
                max: "",
                category_id: "",
                class_type: [],
                class_name: "",
                orderBy: "",
                start_time: "",
                end_time: "",
                region: "",
                town: "",
            },
            timePickerOptions: {
                start: "00:00",
                step: "00:15",
                end: "23:45"
            },
            lastPage: "",
            currentPage: "",
            statusList: [],
            isEnrolling: false, // Flag to prevent multiple clicks
        };
    },

    created() {
        this.isStudent = this.userType == "student" ? true : false;
        this.isTeacher = this.userType == "teacher" ? true : false;
    },

    computed: {
        ...mapGetters(["userType", "teacherId", "studentId"]),
    },

    methods: {
        login() {
            this.$router.push({
                name: "login"
            });
        },

        enrollClass(classId) {
            var request = {
                class_id: classId,
                student_id: this.studentId,
                rate: this.classes.rate
            };
            axios.post("/class/enroll", request)
                .then((response) => {
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                    this.$notification.success("သင်တန်းလျှောက်ထားမှုအောင်မြင်ပါသည်။ သက်ဆိုင်ရာ ဆရာ/ဆရာမ မှ ပြန်လည်ဆက်သွယ်ပေးပါလိမ့်မည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$modal.hide("dialog");
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    else if(error.response.status == 400) {
                        this.$notification.error("သင်တန်းလျှောက်ထားပြီးပါပြီ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.class_error = error.errors;
                        this.$notification.error(this.class_error, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }                   
                    this.$modal.hide("dialog");
                });
        },

        confirmLogin(classId) {
            this.$modal.show("dialog", {
                title: "သင်သည် ကျောင်းသားတစ်ယောက် ဖြစ်ပါသလား?",
                text: "အတန်းအပ်ရန်အတွက် ကျောင်းသားအဖြစ် စာရင်းသွင်းရမည် သို့မဟုတ် မိမိအကောင့်သို့ ၀င်ရောက်ရမည်။",
                buttons: [{
                        title: "အကောင့်ဝင်ရန်",
                        handler: () => {
                            this.login(classId);
                        }
                    },
                    {
                        title: "ပယ်ဖျက်ရန်",
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    }
                ]
            });
        },

        confirmEnroll(classId) {
            this.isEnrolling = false; // Reset flag before showing dialog
            this.$modal.show("dialog", {
                title: "အတည်ပြုခြင်း!",
                text: "ဤအတန်းကိုတက်မှာ သေချာပြီလား?",
                buttons: [{
                        title: "တက်မည်",
                        default: true,
                        handler: () => {
                            if (!this.isEnrolling) {
                                this.isEnrolling = true; // Prevent further clicks
                                this.enrollClass(classId).finally(() => {
                                    this.isEnrolling = false; // Reset after completion
                                });
                            }
                        }
                    },
                    {
                        title: "မတက်ပါ",
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    }
                ]
            });
        },
        
        getAllClasses(page = 1) {
            axios.get("class/list" + "?page=" + page)
            .then((response) => {
                this.classes = response.data;
                this.classes.data.forEach(($class, index) => {
                    this.classes.data[index].rate = parseFloat($class.rate); 
                });
                this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('/');
                }
                console.log("Class All List API error", error);
            });     
        },

        resetClassFilter() {
            this.filter = {
                min: "",
                max: "",
                category_id: "",
                class_type: [],
                class_name: "",
                orderBy: "",
                start_time: "",
                end_time: "",
                region: "",
                town: ""
            };
        },

        classFilter(page = 1) {
             axios.post("class/list/filter" + "?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                    // this.currentRefinement.min = this.filter.min ? this.filter.min : 0;
                    // this.currentRefinement.max = this.filter.max ? this.filter.max : 500000;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Class Filter Error", error);
                });            
        },

        onChangeCategory(event) {
            this.filter.category_id = event.target.value;
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.filter.region = Value;
            this.selectedTwspName = "";
            if (Value == '') {
                this.twspName = null;
                this.filter.town = '';
            } else {
                this.twspName = this.changeTwspName(Value);
            }
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.filter.town = Value;
        },
        
        onChange(page = 1) {
            this.filter.orderBy = event.target.value
            axios.post("class/list/filter" + "?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Class Filter Error", error);
                });            
        },
        
        search() {
            axios.get("class/search/result", {
                    params: {
                        keyword: this.keyword
                    }
                })
                .then((response) => {
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Class Search API Error", error);
                });
        },

        getCategoryForCourse() {
            axios.get("course/categories")
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
            });
        },
    },

    mounted() {
        this.getAllClasses();        
        this.getCategoryForCourse();
        //fetchNotificationCount();

        $("#min").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });

        $("#max").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });

        $(document).ready(function() {
            $("#myBtn").click(function(event) {
                event.preventDefault();
                $("html, body").animate({
                    scrollTop: 0
                });
                return false;
            });
            $(window).on('load', function() {
                // Animate loader off screen
                $(".se-pre-con").fadeOut("slow");
            });
        });
    }
};
